import Colors from '@omni/kit/theming/Colors';
import React, { ReactElement } from 'react';
import { View } from 'react-native';

export default function EmptyScreen(): ReactElement {
  return <View style={{ flex: 1, backgroundColor: Colors.N0 }} />;
}
